<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { getLabel } from '@/utils/data-display-utils';
import { Locales } from '@/store/language.interface';

// PROPS
const props = defineProps<{
  openQuestion: any;
  response?: any;
  results?: any;
  showResult?: boolean;
  languageEnabled?: Locales[];
}>();

// REFS
const textAreaValue = ref<string>(props.response && props.response[0].value_text);
const valueObject = ref<any>({
  valueText: props.response && props.response[0].value_text,
  answerId: props.openQuestion.answerId,
});

onMounted(() => {
  if (props.openQuestion.results) {
    textAreaValue.value = props.openQuestion.results[props.openQuestion.answerId];
  }
});

// EMITS
const emit = defineEmits<{
  (e: 'change', response: any): void;
}>();

// FUNCTIONS
function changeValue(value: any) {
  textAreaValue.value = value;
  valueObject.value.valueText = value;
  emit('change', valueObject.value);
}

// WATCH
watch(textAreaValue, (newValue) => {
  valueObject.value.valueText = newValue;
});
</script>

<template>
  <div class="open-question">
    <label for="open-question">
      <q-input
        @update:model-value="changeValue"
        type="textarea"
        :disable="showResult"
        square
        outlined
        name="open-question"
        :model-value="textAreaValue"
        :placeholder="getLabel('form.form-placeholder', props.languageEnabled)"
      />
    </label>
  </div>
</template>

<style lang="scss">
.open-question {
  width: 100%;
  border-radius: 8px;
  margin: $space-sm 0;
  padding: $space-xs;
}
</style>
